import React from "react";
//#region types
import { IncomingInvoiceAlertsProps } from "models/propTypes/incomingInvoicePropTypes";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { useFloatingMessages } from "components/common";
import OCRCollisionMessage from "./oCRCollisionMessage";
import useOCRCollisions from "./useOCRCollisionMessage";
//#endregion

const IncomingInvoiceViewAlerts: React.FC<IncomingInvoiceAlertsProps> = (props) => {
  const { invoice } = props;

  const ocrCollisions = useOCRCollisions(invoice);

  const { enqueueMessage } = useFloatingMessages();

  React.useEffect(() => {
    ocrCollisions.length > 0 &&
      enqueueMessage(
        <Grid>
          <OCRCollisionMessage ocrCollisions={ocrCollisions} />
        </Grid>,
        StyleEnums.DisplayType.Warning
      );
  }, [ocrCollisions]);

  return <></>;
};

export default IncomingInvoiceViewAlerts;
